// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/64d83ea4/" + chunkId + "." + __webpack_require__.h() + ".v64d83ea4.js";
};